import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=123c7cf8&scoped=true&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=123c7cf8&lang=scss&scoped=true&"
import style1 from "./UploadVideo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c7cf8",
  null
  
)

export default component.exports